import { render } from "./AddCleTypeNotificationPage.vue?vue&type=template&id=4fe52cfa&ts=true"
import script from "./AddCleTypeNotificationPage.vue?vue&type=script&lang=ts"
export * from "./AddCleTypeNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__